import { useEffect, useRef } from 'react';
import FlowStateManager from './flow-state-manager';
import prepareFormValues from './prepare-form-values';

export default function useNavigator(
  reset: (values: Record<string, any>) => void,
  stateManager: FlowStateManager
) {
  const initialPageIndex = useRef(0);

  useEffect(() => {
    const handlePop = async (e) => {
      if (stateManager.getActivePage()) {
        // ^ can only get back from active page, do nothing for terminal pages

        const index = e.state?.index ?? initialPageIndex.current;
        if (index !== undefined) {
          stateManager.getActivePage();
          const formValues = await stateManager.goToPage(index);
          reset(prepareFormValues(formValues));
        }
      }
    };
    window.addEventListener('popstate', handlePop);
    initialPageIndex.current = stateManager.getCurrentPageIndex();

    return () => {
      window.removeEventListener('popstate', handlePop);
    };
  }, [reset, stateManager]);
}
